// src/tenant-products/defaults.ts
var TENANT_PRODUCT_SHELL_HUBS = [
  {
    key: "library",
    title: "Question bank",
    segment: "library",
    iconClass: "fa-light fa-books",
    iconActiveClass: "fa-solid fa-books",
    secondaryPanel: "library"
  },
  {
    key: "placements",
    title: "Placements",
    segment: "placements",
    iconClass: "fa-light fa-location-dot",
    iconActiveClass: "fa-solid fa-location-dot"
  }
];
var TENANT_PRODUCT_SHELL_HUB_SEGMENTS = TENANT_PRODUCT_SHELL_HUBS.map(
  (h) => h.segment
);
function libraryNavChildren(root) {
  return [
    {
      key: "library-hub",
      title: "Library home",
      url: `${root}/library`,
      iconClass: "fa-light fa-sparkles",
      iconActiveClass: "fa-solid fa-sparkles"
    },
    {
      key: "library-search",
      title: "Search",
      url: `${root}/library/find`,
      iconClass: "fa-light fa-magnifying-glass",
      iconActiveClass: "fa-solid fa-magnifying-glass"
    },
    {
      key: "library-all",
      title: "Library",
      url: `${root}/library/all`,
      iconClass: "fa-light fa-table-list",
      iconActiveClass: "fa-solid fa-table-list"
    }
  ];
}
function defaultTenantNavForSlug(slug) {
  const root = `/${slug}`;
  return [
    {
      key: "dashboard",
      title: "Dashboard",
      url: `${root}/dashboard`,
      iconClass: "fa-light fa-gauge-high",
      iconActiveClass: "fa-solid fa-gauge-high"
    },
    ...TENANT_PRODUCT_SHELL_HUBS.map((hub) => {
      const link = {
        key: hub.key,
        title: hub.title,
        url: `${root}/${hub.segment}`,
        iconClass: hub.iconClass,
        iconActiveClass: hub.iconActiveClass
      };
      if ("secondaryPanel" in hub && hub.secondaryPanel) {
        link.secondaryPanel = hub.secondaryPanel;
        link.primaryHubChildKey = `${hub.key}-hub`;
      }
      if (hub.key === "library") {
        link.children = libraryNavChildren(root);
        link.primaryHubChildKey = "library-all";
      }
      return link;
    })
  ];
}
var DEFAULT_TENANT_BRAND_PREFIX = "Exxat";

export {
  TENANT_PRODUCT_SHELL_HUBS,
  TENANT_PRODUCT_SHELL_HUB_SEGMENTS,
  defaultTenantNavForSlug,
  DEFAULT_TENANT_BRAND_PREFIX
};
